import { motion } from "framer-motion";
import { LOGO } from "@/content/site";

const BRAND_WORDS = ["Local.", "Reliable.", "Refreshing."];

export const BrandMark = () => (
  <section data-testid="brand-mark-section" className="py-16 sm:py-24 bg-white overflow-hidden">
    <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto flex flex-col items-center text-center">
      <motion.img
        src={LOGO.badge}
        alt="Point of Pines Pools & Service logo — pines, sunset, and a clear pool in Pinellas County FL"
        data-testid="brand-mark-logo"
        initial={{ opacity: 0, scale: 0.82, y: 30 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="w-52 sm:w-64 lg:w-80 h-auto drop-shadow-xl"
      />
      <div className="mt-8 sm:mt-10 flex flex-wrap justify-center gap-x-8 gap-y-2">
        {BRAND_WORDS.map((w, i) => (
          <motion.span
            key={w}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.35 + i * 0.15 }}
            className={`font-display text-lg sm:text-xl font-bold tracking-tight ${
              i === 1 ? "text-pool" : i === 2 ? "text-lagoon" : "text-navy"
            }`}
          >
            {w}
          </motion.span>
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.8 }}
        className="mt-4 text-xs font-mono uppercase tracking-[0.3em] text-slate-400"
      >
        Pinellas County, Florida
      </motion.p>
    </div>
  </section>
);
